import { render, staticRenderFns } from "./Bookevent.vue?vue&type=template&id=bcad0cb8&"
import script from "./Bookevent.vue?vue&type=script&lang=js&"
export * from "./Bookevent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports